module.exports = __webpack_public_path__ + "static/media/ta_soiree.57bed44b.mp3";